import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { QuestionsService, PropagateQuestionUpdatesResult } from '_services/questions.service';

export interface PropagateQuestionDialogData {
  questionId: string;
  questionLabel: string;
  aidYear: number;
}

type PropagatePhase = 'confirm' | 'working' | 'result' | 'error';

@Component({
  selector: 'app-propagate-question-dialog',
  templateUrl: './propagate-question-dialog.component.html',
  styleUrls: ['./propagate-question-dialog.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class PropagateQuestionDialogComponent {
  phase: PropagatePhase = 'confirm';
  result: PropagateQuestionUpdatesResult | null = null;
  errorMessage = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropagateQuestionDialogData,
    private dialogRef: MatDialogRef<PropagateQuestionDialogComponent>,
    private questions: QuestionsService
  ) {}

  async updateLists(): Promise<void> {
    if (this.phase === 'working') {
      return;
    }
    this.phase = 'working';
    this.errorMessage = '';
    this.dialogRef.disableClose = true;
    try {
      this.result = await this.questions.propagateQuestionUpdates(this.data.aidYear, [this.data.questionId]);
      this.phase = 'result';
    } catch (err) {
      this.errorMessage = err instanceof Error ? err.message : 'Unable to update school lists';
      this.phase = 'error';
    } finally {
      this.dialogRef.disableClose = false;
    }
  }
}
